import React from 'react'
import SMSFeature from './SMSFeature'

function SmsMessages() {
  return (
    <SMSFeature />
  )
}

export default SmsMessages